import React, { Component } from 'react';
import { login } from '../helpers/auth'
import { firebaseAuth } from '../config/constants'


class LogIn extends Component {
	constructor(){
		super();
		this.authSubmit = this.authSubmit.bind(this);
    
		//this.authHandler = this.authHandler.bind(this);
        this.state={
          loginMessage:null
        }
	}
	
	
  	authSubmit(e) {		
        e.preventDefault();
        login(this.email.value,this.password.value)
        .catch((error) => {
              this.setState({loginMessage:'Invalid username or password.'});
            })
        firebaseAuth().onAuthStateChanged(user=>{
          if (user){

            window.location = "/";
          }
        });
    }
    
  	render() {

    	return (
            <div>
            <div id="forBackground">
                <img src="img/placeholders/backgrounds/bgfull3.jpg" alt="Login Background" className="full-bg animation-pulseSlow"/>

                <div id="login-container" className="animation-fadeIn">
                    <div className="login-title text-center">
                        <div className="solapologoholder"><img src="img/placeholders/logo/solapoorig.png"/></div>
                        <h1><strong>SOLAPO ROOFING</strong></h1>
                        
                    </div>
                    <div className="block push-bit">
                        <form id="form-login" className="form-horizontal form-bordered form-control-borderless" ref={(input) => {this.loginForm=input}} onSubmit={(e)=>this.authSubmit(e)}>
                            <div className="form-group">
                                <div className="col-xs-12">
                                    <div className="input-group loginInputArea">
                                        <span className="input-group-addon"><i className="gi gi-envelope"></i></span>
                                        <input type="text" id="login-email" name="login-email" className="form-control input-lg" placeholder="Email" ref={(input) => {this.email=input}} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-12">
                                    <div className="input-group loginInputArea">
                                        <span className="input-group-addon"><i className="gi gi-asterisk"></i></span>
                                        <input type="password" id="login-password" name="login-password" className="form-control input-lg" placeholder="Password" ref={(input) => {this.password=input}} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-actions">
                                <div className="col-xs-12 text-center">
                                    <button type="submit" className="btn btn-sm btn-primary" ><i className="fa fa-angle-right"></i> Login to Dashboard</button>
                                    {
                                      this.state.loginMessage &&
                                      <div className="loginError">
                                        <span className="sr-only">Error:</span>
                                        &nbsp;{this.state.loginMessage} 
                                      </div>
                                    }
                                </div>
                            </div>
                        </form>            
                    </div>
                </div>

            </div>
            </div>
	    );
	}
}


export default LogIn;



// WEBPACK FOOTER //
// ./src/components/LogIn.js